import { useField } from 'formik'
import { FieldSchema } from 'components/Wizards/Wizard/Form/Types'
import Styles from './Fields.module.scss'
import { Chip } from 'components/Chip/Chip'
import classNames from 'classnames'

interface CountFieldProps {
  name: string
  schema: FieldSchema
}

export const CountField = ({ name, schema }: CountFieldProps) => {
  const [field, , { setValue: setCount }] = useField(name)
  const { oneOf } = schema.describe()

  return (
    <div className={classNames(Styles.chips, Styles.countChips)}>
      {(oneOf && oneOf.length > 0 ? oneOf : [1, 2, 3, 4, 5, 6]).map((value) => (
        <Chip
          key={value}
          aria-label={`${value}`}
          deletable={false}
          variant="flat"
          size="md"
          className={classNames(Styles.countChip)}
          onPress={() => setCount(value)}
          isSelected={Number(field.value) === value}
        >
          {value}
        </Chip>
      ))}
    </div>
  )
}
